import { TRADE_BOARDCAST_RIGHT_BAR_ACTIONS } from "../../actionType/TradeBoardCast";


const intialState = {
    TradeBoardCastRightBar: [],
    isTradeBoardCastRightBarLoader: false
};

export const tradeBoardCastReducer = (
    state = intialState,
    { type, payload }: any
) => {

    switch (type) {
        case TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_REQUEST:
            return { ...state, isTradeBoardCastRightBarLoader: true };
        case TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_RESPONSE:
            return {
                ...state, 
                TradeBoardCastRightBar: payload,
                isTradeBoardCastRightBarLoader: false
            };
        case TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_ERROR:
            return {
                ...state,
                TradeBoardCastRightBar: payload,
                isTradeBoardCastRightBarLoader: false,
            };
        default:
            return state;
    }
}



// export const tradeBoardCastReducer = (state = intialState, { type, payload }: any) => {
//     switch (type) {
//         // TRADE_BOARDCAST_RIGHT_BAR_DATA

//         case TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_REQUEST:
//             return { ...state, TradeBoardCastRightBar: payload, isTradeBoardCastRightBarLoader: true };
//         case TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_RESPONSE:
//             return { ...state, TradeBoardCastRightBar: payload, isTradeBoardCastRightBarLoader: false };

//         case TRADE_BOARDCAST_RIGHT_BAR_ACTIONS.TRADE_BOARDCAST_RIGHT_BAR_ACTIONS_ERROR:

//             return { ...state, TradeBoardCastRightBar: payload, isTradeBoardCastRightBarLoader: false };
//     }
// };
